import React from "react";
import styled from "styled-components";
import TextAtm from "../../../atoms/TextAtm";
var PromoPrefix = styled(TextAtm).withConfig({
  componentId: "sc-1j774w6-0"
})(["color:rgba(255,255,255,0.7);font-feature-settings:\"clig\" off,\"liga\" off;"]);
var CategoryPromoPrefix = function CategoryPromoPrefix(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(PromoPrefix, {
    typography: "xsmall1"
  }, children);
};
export default CategoryPromoPrefix;